import { render, staticRenderFns } from "./CustomerLedgerReport.vue?vue&type=template&id=c1fd7bf0&scoped=true&"
import script from "./CustomerLedgerReport.vue?vue&type=script&lang=js&"
export * from "./CustomerLedgerReport.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLedgerReport.vue?vue&type=style&index=0&id=c1fd7bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fd7bf0",
  null
  
)

export default component.exports